import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";

import { BoxOwner } from "../../../../dtos/box";
import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useBoxOwners(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [owners, setOwners] = useState<BoxOwner[]>([]);

    const load = useCallback(() => {
        setLoading(true);
        boxApi.getOwners(boxId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setOwners(r.data)
            } else {
                enqueueSnackbar("Failed to load box data!", { variant: "error" });
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    useEffect(() => {
        load();
    }, [load]);

    return { owners, load, loading };
}
